import React, {useEffect, useState} from "react";
import {useSubheader} from "../../../_metronic/layout";
import {Checkbox, Paper, Table, TableBody, TableCell, TableRow, TablePagination, TextField,IconButton,Popover,Typography} from "@material-ui/core";
import {Dropdown, Button} from "react-bootstrap";
import EnhancedTableHead from "../../components/EnhancedTableHead";
import makeRequest from "../../api/makeRequest";
import {Link} from "react-router-dom";
import {DropdownCustomToggler} from "../../../_metronic/_partials/dropdowns";
import {DashboardRoomMenu} from "../../../_metronic/_partials/dropdowns/DashboardRoomMenu";
import {useTranslation} from "react-i18next";
import apiConfig from "../../config/apiConfig";
import {Share as ShareIcon,Visibility as VisibilityIcon, GetApp as GetAppIcon} from "@material-ui/icons";
import moment from "moment-jalaali";
import axios from "axios";

export const RoomSessionsPage = ({match}) => {
	const { t } = useTranslation('common');
	const headRows = [
		{id: "id", disablePadding: true, label: t('Id')},
		{id: "start_time", disablePadding: false, label: t('Start')},
		{id: "end_time", disablePadding: false, label: t('End')},
		{id: "end", disablePadding: false, label: t('Ended')},
		{id: "duration", disablePadding: false, label: t('Time')},
		{id: "operation", disablePadding: false, label: t('Operations')},
		{id: "actions", disablePadding: false, label: t('Actions')}
	];
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('RoomSessions'));

	const [RoomSessions, setRoomSessions] = useState([])
	const [Room, setRoom] = useState({})
	const [selected, setSelected] = React.useState([]);
	const [orderBy, setOrderBy] = React.useState("_id");
	const [order, setOrder] = React.useState("desc");
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(25);
	const [totalDocs, setTotalDocs] = React.useState(0);

	const [search,setSearch] = useState({})
	const [requestSearch,setRequestSearch] = useState(false)

	const [OpenShare,setOpenShare] = useState(0)
	const [anchorEl, setAnchorEl] = useState(null);

	useEffect(()=>{
		moment.loadPersian();
	},[])
	useEffect(() => {
		const getRoomSessions = async () => {
			try {
				const query = {
					page:page+1,
					per_page:rowsPerPage
				}
				const {data} = await makeRequest('getRoomSessions', {id:match.params.rid,search},query)
				const sessions = data.sessions.docs
				const room = data.sessions.room
				setRoomSessions(sessions)
				setRoom(room)
				setTotalDocs(data.sessions.totalDocs)
			} catch (e) {
				console.log(e)
			}
		}

		getRoomSessions()

	}, [page,rowsPerPage,requestSearch,match])



	function handleSelectAllClick(event) {
		if (event.target.checked) {
			const newSelecteds = RoomSessions.map(n => n.name);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	}

	function handleRequestSort(event, property) {
		const isDesc = orderBy === property && order === "desc";
		setOrder(isDesc ? "asc" : "desc");
		setOrderBy(property);
	}

	function stableSort(array, cmp) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = cmp(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map(el => el[0]);
	}

	function desc(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getSorting(order, orderBy) {
		return order === "desc"
			? (a, b) => desc(a, b, orderBy)
			: (a, b) => -desc(a, b, orderBy);
	}

	const isSelected = name => selected.indexOf(name) !== -1;

	function handleClick(event, name) {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}

		setSelected(newSelected);
	}

	const emptyRows =
		rowsPerPage - Math.min(rowsPerPage, RoomSessions.length - page * rowsPerPage);

	function handleChangePage(event, newPage) {
		setPage(newPage);
	}

	function handleChangeRowsPerPage(event) {
		setPage(0)
		setRowsPerPage(parseInt(event.target.value, 10));
	}

	const handleDownloadCSV = async (sessionId) => {
		try {
			const BASE_URL = apiConfig.BASE_URL;
			const url = `${BASE_URL}api/panel/export/session/connections/${sessionId}`;
			
			const response = await axios.get(url, {
				responseType: 'blob'
			});
			
			const blob = new Blob([response.data], { type: 'text/csv' });
			const downloadUrl = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = downloadUrl;
			a.download = `session_${sessionId}_connections_${Date.now()}.csv`;
			document.body.appendChild(a);
			a.click();
			window.URL.revokeObjectURL(downloadUrl);
			document.body.removeChild(a);
		} catch (error) {
			console.error('Failed to download CSV:', error);
		}
	};

	return (
		<>
			{/* <div className="new-room">
				<Link to={'/room/new'}><Button variant="outline-primary mb-5">{t('MENU.NEW')}</Button></Link>
			</div> */}
			{/* <SearchInputs
				onSearch={(e)=>{
					setSearch(e)
					setRequestSearch(prev=>!prev)
				}}
				showReset={JSON.stringify(search) !== "{}"}
			/> */}
			<Paper className={"classes.paper"}>
				<div className={"tableWrapper"}>
					<Table
						className={"classes.table"}
						aria-labelledby="tableTitle"
						size={"medium"}
					>
						<EnhancedTableHead
							numSelected={selected.length}
							order={order}
							orderBy={orderBy}
							onSelectAllClick={handleSelectAllClick}
							onRequestSort={handleRequestSort}
							rowCount={RoomSessions.length}
							headRows={headRows}
						/>
						<TableBody>
							{stableSort(RoomSessions, getSorting(order, orderBy))
								.map((row, index) => {
									const isItemSelected = isSelected(row.id);
									const labelId = `enhanced-table-checkbox-${index}`;
									const link = `${(row.slug ? `${apiConfig.BASE_URL}w/${row.service_id}/${row.slug}` : `${apiConfig.BASE_URL}room/${row.id}/${row.link}`)}?lang=${t('lang')}`
									return (
										<TableRow
											hover
											onClick={event => handleClick(event, row.id)}
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.id}
											selected={isItemSelected}
										>
											<TableCell padding="checkbox">
												<Checkbox
													checked={isItemSelected}
													inputProps={{
														"aria-labelledby": labelId
													}}
												/>
											</TableCell>
											<TableCell
												component="th"
												id={labelId}
												align="right"
											>
												{row._id}
											</TableCell>
											<TableCell align="right">{moment.unix(row.start_time).format("HH:mm jYYYY/jMM/jDD")}</TableCell>
											<TableCell align="right">{moment.unix(row.end_time).format("HH:mm jYYYY/jMM/jDD")}</TableCell>
											<TableCell align="right">{row.end ? t('Yes') : t('No')}</TableCell>
											<TableCell align="right">{Math.max((row.end_time - row.start_time)/60,0).toFixed(1)}</TableCell>
											<TableCell align="right">
												<Link to={`/room/session/${match.params.rid}/attendance/${row._id}`}>
													<IconButton color="primary" component="span">
														<VisibilityIcon/>
													</IconButton>
												</Link>
											</TableCell>
											<TableCell align="right">
												<IconButton
													color="primary"
													size="small"
													onClick={(e) => {
														e.stopPropagation();
														handleDownloadCSV(row._id);
													}}
													title={t('DownloadCSV')}
												>
													<GetAppIcon />
												</IconButton>
											</TableCell>
										</TableRow>
									);
								})}
							{emptyRows > 0 && (
								<TableRow style={{height: 49 * 5}}>
									<TableCell colSpan={6}/>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</div>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25, 50, 100]}
					component="div"
					labelRowsPerPage={t('NumberPerPage')}
					count={totalDocs}
					rowsPerPage={rowsPerPage}
					page={page}
					backIconButtonProps={{
						"aria-label": "Previous Page"
					}}
					nextIconButtonProps={{
						"aria-label": "Next Page"
					}}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
			</Paper>
		</>
	);
};
const ItemDropdown = ({item,onDelete}) => {
	return (<>
		<Dropdown className="dropdown-inline" alignRight>
			<Dropdown.Toggle
				id="dropdown-toggle-top"
				as={DropdownCustomToggler}>
				<i className="ki ki-bold-more-hor"/>
			</Dropdown.Toggle>
			<Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
				<DashboardRoomMenu item={item} onDelete={onDelete}/>
			</Dropdown.Menu>
		</Dropdown>
	</>);
};

const SearchInputs = React.memo(({onSearch,showReset=false})=>{
	const [name,setName] = useState('')
	const { t } = useTranslation('common')
	const [id,setId] = useState('')
	return(
		<div className='flex justify-content-between align-items-center my-5'>
			<form  onSubmit={(e)=> {
				e.preventDefault()
				onSearch({name, id})
			}}>
				<TextField onChange={(e)=>setName(e.target.value)} className='mx-2 my-2' label={t('Name')} variant="outlined"/>
				<TextField onChange={(e)=>setId(e.target.value)} className='mx-2 my-2' label={t('Id')} variant="outlined"/>
				<Button type='submit' className='mx-2 my-2' style={{lineHeight:"2.6"}}>{t('ECOMMERCE.COMMON.SEARCH')}</Button>
				{showReset ? <Button type='reset' onClick={()=>onSearch({})} className='mx-2 my-2' style={{lineHeight:"2.6"}} variant="outline-danger">{t('RemoveFilter')}</Button> : null}
			</form>

		</div>
	)
})